const LUCID_DEV_TOOLS_QUERY_KEYS = {
    Base: 'lucid_dev_tools',
    LoggedInFilespaces: 'logged_in_filespaces',
    ShownLogs: 'shown_logs',
    SerializedStats: 'serialized_stats',
};
export const LucidDevToolsKeyFactory = {
    all: () => [LUCID_DEV_TOOLS_QUERY_KEYS.Base],
    loggedInFilespaces: () => [
        ...LucidDevToolsKeyFactory.all(),
        LUCID_DEV_TOOLS_QUERY_KEYS.LoggedInFilespaces,
    ],
    shownLogs: () => [
        ...LucidDevToolsKeyFactory.all(),
        LUCID_DEV_TOOLS_QUERY_KEYS.ShownLogs,
    ],
    allSerializedStats: () => [
        ...LucidDevToolsKeyFactory.all(),
        LUCID_DEV_TOOLS_QUERY_KEYS.SerializedStats,
    ],
    serializedStats: (statsName) => [
        ...LucidDevToolsKeyFactory.allSerializedStats(),
        statsName,
    ],
};
